import { render } from "./About.vue?vue&type=template&id=1ae8a7be"
const script = {}

import exportComponent from "C:\\Users\\zhuxu\\source\\repos\\innosource\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__